module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-backplates-remnants.9e2a033f.png";